var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      attrs: {
        "data-cy": `${_vm.name}-btn-schedule`,
        href: "javascript:void(0);",
      },
    },
    [
      _c("b-img", {
        staticClass: "no-checkbox cls-img-btn ml-2",
        attrs: {
          id: "schedule-" + _vm.id,
          src: "/assets/icons/work-schedule.svg",
        },
        on: { click: _vm.onClick },
      }),
      _vm._v(" "),
      _c("b-tooltip", {
        attrs: {
          target: "schedule-" + _vm.id,
          placement: "bottom",
          title: _vm.$t("tool-tips.schedule"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }